import React, { useEffect } from "react";
import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Grid,
  Tabs,
  Tab,
  Divider,
  FormGroup,
  FormControlLabel,
  Checkbox,
  CircularProgress,
} from "@mui/material";
import TabPanel from "../../components/TabPanel";
import InvoiceItems from "./invoice/items";
import InvoiceCommunication from "./invoice/communication";
import InvoiceSystemInformation from "./invoice/systemInformation";
import InvoiceCustom from "./invoice/custom";
import { useSelector } from "react-redux";
import useSnackbar from "../../hooks/useSnackbar";
import { getTransactionInvoiceDetail } from "../../api/invoice";
import {
  GridComp12,
  GridComp4,
  GridComp6,
} from "../../components/GridComponents";
import { CustomCheckBox } from "../../components/CheckboxComp";
import { makeStyles } from "@mui/styles";
import SalesOrderRelatedRecords from "./invoice/related-records";
import InvoiceCharges from "./invoice/charges";
import InvoiceShipping from "./invoice/shipping";
import InvoiceAccounting from "./invoice/accounting";
import InvoiceRelationship from "./invoice/relationship";
import InvoiceAvaTax from "./invoice/ava-tax";
import InvoiceEft from "./invoice/eft";
import InvoiceTaxAndReporting from "./invoice/tax&reporting";
import InvoiceBilling from "./invoice/billing";
const useStyles = makeStyles((theme) => ({
  spacedTabs: {
    "& .MuiTab-root": {
      marginRight: theme.spacing(2), // Adjust the spacing as needed
    },
  },
}));
export default function TransactionTypeInvoice() {
  const classes = useStyles();
  const snackbar = useSnackbar();
  const params = useParams();
  const [rowData, setRowData] = useState([]);
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const { data: user } = useSelector((state) => state.user);
  /*----------------Tabs-----------------*/
  const [tabIndex, setTabIndex] = useState(0);
  const [tabIndexRelationship, setTabIndexRelationship] = useState(0);
  const [tabIndexApproveList, setTabIndexApproveList] = useState(0);
  const [tabIndexAvaTax, setTabIndexAvaTax] = useState(0);
  const [tabIndexRelatedRecord, setTabIndexRelatedRecord] = useState(0);
  const [linkingdocumentno, setlinkingdocumentno] = useState("");
  const [itemsum, setSum] = useState("");
  /*----------------End Tabs-----------------*/
  useEffect(() => {
    if (user.token) {
      getTransactionDocDetailTableData();
    }
  }, []);
  async function getTransactionDocDetailTableData() {
    setLoading(true);
    try {
      const { data } = await getTransactionInvoiceDetail(user.token, {
        tranid: params.docNo,
        // type: pageDetail.path,
      });
      setData(data.data);
      setRowData(data.data.details);
      setLoading(false);

      return {
        rows: data.data.details,
        total: data.data.Detailstotal,
        error: false,
      };
    } catch (error) {
      setLoading(false);

      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }

  console.log(rowData,"rowData")
  return loading ? (
     <>
       <Typography component="h2" fontWeight={500} className="pageTitle">
       Invoice
       </Typography>
 
       {/*Primary Information*/}
       <Box className="viewBox">
         <Box
           className="headerItems"
           display="flex"
           alignItems="center"
           justifyContent="space-between"
           pb={2}
         >
           <Typography component="h5" fontWeight={500} className="pageHeading1">
             Primary Information
           </Typography>
           <Link to={"/transaction-type/" + params.slug}>
             <Button size="small" variant="contained" className="backBtn">
               Go Back
             </Button>
           </Link>
         </Box>
         <Box className="viewDetilsBox">
           <Grid container className="mb-2">
             <Grid item xs={12}>
               <p
                 style={{
                   width: "100%",
                   display: "flex",
                   justifyContent: "center",
                   alignItems: "center",
                 }}
               >
                 <CircularProgress></CircularProgress>
               </p>
             </Grid>
           </Grid>
         </Box>
       </Box>
     
 
       {/*Classification*/}
       <Box className="viewBox">
         <Box
           className="headerItems"
           display="flex"
           alignItems="center"
           justifyContent="space-between"
           pb={2}
         >
           <Typography component="h5" fontWeight={500} className="pageHeading1">
             Classification
           </Typography>
         </Box>
         <Box className="viewDetilsBox">
           <Grid container className="mb-2">
             <Grid item xs={12}>
               <p
                 style={{
                   width: "100%",
                   display: "flex",
                   justifyContent: "center",
                   alignItems: "center",
                 }}
               >
                 <CircularProgress></CircularProgress>
               </p>
             </Grid>
           </Grid>
         </Box>
       </Box>
       <Box className="viewBox">
         <Box
           className="headerItems"
           display="flex"
           alignItems="center"
           justifyContent="space-between"
           pb={2}
         >
           <Typography component="h5" fontWeight={500} className="pageHeading1">
           Avatax/Others
           </Typography>
         </Box>
         <Box className="viewDetilsBox">
           <Grid container className="mb-2">
             <Grid item xs={12}>
               <p
                 style={{
                   width: "100%",
                   display: "flex",
                   justifyContent: "center",
                   alignItems: "center",
                 }}
               >
                 <CircularProgress></CircularProgress>
               </p>
             </Grid>
           </Grid>
         </Box>
       </Box>
       <Box className="viewBox">
         <Box
           className="headerItems"
           display="flex"
           alignItems="center"
           justifyContent="space-between"
           pb={2}
         >
           
         </Box>
         <Box className="viewDetilsBox">
           <Grid container className="mb-2">
             <Grid item xs={12}>
               <p
                 style={{
                   width: "100%",
                   display: "flex",
                   justifyContent: "center",
                   alignItems: "center",
                 }}
               >
                 <CircularProgress></CircularProgress>
               </p>
             </Grid>
           </Grid>
         </Box>
       </Box>
     </>
   ) : (
    <>
      {/*Primary Information*/}
      <Typography component="h4" fontWeight={500} className="pageTitle">
        Invoice
      </Typography>

      {rowData.map((el, index) => (<>
        <Typography component="h5" style={{marginBottom: "10px"}}>
               {rowData.map((d, i) => (
                 <span className="para-no">
                   <strong>{d.invoice_id}</strong> {" "}
                   {d.customer}
          </span>
          ))}
           {" "}
           <Button className="blue-button" size="small">
                    {rowData[0].status}
                  </Button>
        </Typography>
        <Box className="viewBox" key={index}>
          <Box
            className="headerItems"
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            pb={2}
          >
            <Typography
              component="h5"
              fontWeight={500}
              className="pageHeading1"
            >
              Primary Information
            </Typography>
            <Link to={"/transaction-type/" + params.slug}>
              <Button size="small" className="backBtn">
                Go Back
              </Button>
            </Link>
          </Box>
          <Box className="viewDetilsBox">
            <>
              <Grid container className="mb-2">
                <Grid item xs={12} sm={6} md={8}>
                  <Grid container className="mb-2">
                    <GridComp4 title={"INVOICE ID"} data={el.invoice_id} />
                    <GridComp4 title={"INVOICE DATE"} data={el.invoice_date} />
                    <GridComp4
                      title={"PURCHASE ORDER NO."}
                      data={el.purchase_order_no}
                    />
                    <GridComp4 title={"CUSTOMER"} data={el.customer} />
                    <GridComp4
                      title={"POSTING PERIOD"}
                      data={el.posting_period}
                    />
                   
                    <GridComp4 title={"MEMO"} data={el.memo} />
                    <GridComp4 title={"PC/PROJECT"} data={el.pc_project} />
                    <GridComp4 title={"JOB"} data={el.job} />
                    <GridComp4 title={"DUE DATE"} data={el.due_date} />
                    <GridComp4 title={"CUSTOMER ID"} data={el.customer_id} />
                    <GridComp4  />
                    <GridComp4  />
                    <GridComp4
                      title={"SERVICE PERIOD"}
                      data={el.service_period}
                    />
                     <GridComp4
                      title={"PROJECT ID"}
                      data={el.project_id}
                    />
                  </Grid>
                </Grid>
                {/* -----------Summary Box------------- */}
                <Grid item xs={12} sm={6} md={4}>
                  <Box className="viewBox">
                    <Box
                      className="headerItemsSB"
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                      pb={2}
                    >
                      <Typography
                        component="h5"
                        fontWeight={500}
                        className="pageHeading1"
                      >
                        Summary
                      </Typography>
                    </Box>
                    <Box className="viewDetilsBox1">
                      <Grid container>
                        <Grid item xs={12} sm={6} md={6} className="m-b-10">
                          <p className="tFormlabel">SUBTOTAL</p>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} className="m-b-10">
                          <p className="tFormtotal">{el?.foreigntotal}</p>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} className="m-b-10">
                          <p className="tFormlabel">DISCOUNT ITEM</p>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} className="m-b-10">
                          <p className="tFormtotal">{el?.discount_item}</p>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} className="m-b-10">
                          <p className="tFormlabel">TAX TOTAL</p>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} className="m-b-10">
                          <p className="tFormtotal">{el?.tax_total}</p>
                        </Grid>
                        </Grid>
                      <Divider />
                      <Grid container sx={{ mt: 1 }}>
                        <Grid item xs={12} sm={6} md={6} className="m-b-10">
                          <p className="tFormlabel">TOTAL</p>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} className="m-b-10">
                          <p className="tFormtotal">{el.total}</p>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} className="m-b-10">
                          <p className="tFormlabel">AMOUNT DUE</p>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} className="m-b-10">
                          <p className="tFormtotal">{el.amountdue}</p>
                        </Grid>
                      </Grid>
                    </Box>
                  </Box>
                </Grid>
                {/* -----------End Summary Box------------- */}
                {/* <GridComp4 title={"DUE DATE"} data={el.due_date} />
                <GridComp4 title={"CURRENCY"} data={el.currency} />
                <GridComp4 title={"EXCHANGE RATE"} data={el.exchangerate} />
                <GridComp4
                  title={"RBA EXCHANGE RATE"}
                  data={el.rba_exchange_rate}
                />
                <GridComp4
                  title={"RBA EXCHANGE RATE DATE"}
                  data={el.rba_exchange_rate_date}
                />
                <CustomCheckBox
                  title={"CUSTOMER SELF-REMITS TAXES"}
                  data={el.customer_self_remits_taxes}
                />
                <CustomCheckBox
                  title={"PO/AFE REQUIRED"}
                  data={el.po_afe_required}
                />
                <GridComp4
                  title={"CUSTOMER PO#/AFE#"}
                  data={el.customer_po_afe_number}
                />
                <GridComp4 title={"TERMS"} data={el.terms} />
                <GridComp4
                  title={"SUBMITTING GUIDELINES"}
                  data={el.submitting_guidelines}
                />
                <GridComp4
                  title={"REMITTANCE INFO"}
                  data={el.remittance_info}
                />
                <GridComp4
                  title={"MEMO TO CUSTOMER"}
                  data={el.memo_to_customer}
                />
                <GridComp4 title={"INTERNAL MEMO"} data={el.internal_memo} />
                <CustomCheckBox title={"AGENT?"} data={el.agent} />
                <GridComp4
                  title={"COMMISSION %"}
                  data={el.commission_percentage}
                />
                <GridComp4
                  title={"APPROVAL STATUS"}
                  data={el.approval_status}
                />
                <GridComp4 title={"NEXT APPROVER"} data={el.next_approver} />
                <GridComp4 title={"AR COMMENTS"} data={el.ar_comments} /> */}
              </Grid>
            </>
          </Box>
        </Box>
      </>
      ))}
       {/*Classification*/}
       {rowData.map((el, index) => (
        <Box className="viewBox" key={index}>
          <Box
            className="headerItems"
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            pb={2}
          >
            <Typography
              component="h5"
              fontWeight={500}
              className="pageHeading1"
            >
              Classification
            </Typography>
          </Box>
          <Box className="viewDetilsBox">
            <Grid container className="mb-2">
                <Grid container  className="mb-2">
              
                  <GridComp4 title={"SUBSIDIARY"} data={el.subsidiary} />
                 
                  <GridComp4 title={"DEPARTMENT"} data={el.department} />
                  <GridComp4 title={"SERVICE LINE"} data={el.service_line} />
                </Grid>
             </Grid>
          </Box>
        </Box>
      ))}
      {/*Avatar/others*/}
       {rowData.map((el, index) => (
        <Box className="viewBox" key={index}>
          <Box
            className="headerItems"
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            pb={2}
          >
            <Typography
              component="h5"
              fontWeight={500}
              className="pageHeading1"
            >
             Avatax/Others
            </Typography>
          </Box>
          <Box className="viewDetilsBox">
            <>
              <Grid container className="mb-2">
                <GridComp4 title={"SHIP TO ENTITY/USE CODE (2)"} data={el.ship_to_entity_use_code} />
                <GridComp4 title={"INVOICE MESSAGING"} data={el.invoice_messaging} />
                <GridComp4 title={"CUSTOM DUTY AND IMPORT FEES"} data={el.custome_duty_and_import_fees} />
                <GridComp4 title={"BILL-TO ENTITY/USE CODE"} data={el.bill_to_entity_use_code} />
                {el.is_seller_importer_of_period === "F" ||
            el.is_seller_importer_of_period === "" ? (
              <Grid item xs={12} sm={4} md={4} className="m-b-10">
                <p className="tFormlabel">
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox  disabled/>}
                      label="IS SELLER IMPORTER OF RECORD"
                    />
                  </FormGroup>
                </p>
              </Grid>
            ) : (
              <Grid item xs={12}sm={4} md={4} className="m-b-10">
                <p className="tFormlabel">
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked disabled/>}
                      label="IS SELLER IMPORTER OF RECORD"
                    />
                  </FormGroup>
                </p>
              </Grid>
            )}
                {/* <CustomCheckBox title={"IS SELLER IMPORTER OF RECORD"} data={el.is_seller_importer_of_period} /> */}
                {el.exclude_from_electronic_bank_payments_processing === "F" ||
            el.exclude_from_electronic_bank_payments_processing === "" ? (
              <Grid item xs={12} sm={4} md={4} className="m-b-10">
                <p className="tFormlabel">
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox  disabled/>}
                      label="EXCLUDE FROM ELECTRONIC BANK PAYMENTS PROCESSING"
                    />
                  </FormGroup>
                </p>
              </Grid>
            ) : (
              <Grid item xs={12}sm={4} md={4} className="m-b-10">
                <p className="tFormlabel">
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked disabled/>}
                      label="EXCLUDE FROM ELECTRONIC BANK PAYMENTS PROCESSING"
                    />
                  </FormGroup>
                </p>
              </Grid>
            )}
                {/* <CustomCheckBox title={"EXCLUDE FROM ELECTRONIC BANK PAYMENTS PROCESSING"} data={el.exclude_from_electronic_bank_payments_processing} /> */}
                <GridComp4 title={"SOURCE"} data={el.source} />
                {el.disable_avalara_tax_calculation === "F" ||
            el.disable_avalara_tax_calculation === "" ? (
              <Grid item xs={12} sm={4} md={4} className="m-b-10">
                <p className="tFormlabel">
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox  disabled/>}
                      label="DISABLE AVALARA TAX CALCULATION"
                    />
                  </FormGroup>
                </p>
              </Grid>
            ) : (
              <Grid item xs={12}sm={4} md={4} className="m-b-10">
                <p className="tFormlabel">
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked disabled/>}
                      label="DISABLE AVALARA TAX CALCULATION"
                    />
                  </FormGroup>
                </p>
              </Grid>
            )}
                {/* <CustomCheckBox title={"DISABLE AVALARA TAX CALCULATION"}data={el.disable_avalara_tax_calculation}/> */}
                <GridComp4 title={""}  />
                <GridComp4 title={"LOCATION"} data={el.location} />
              </Grid>
            </>
          </Box>
        </Box>
      ))}
      {/*Address Information*/}
      {/* {rowData.map((el, index) => (
        <Box className="viewBox" key={index}>
          <Box
            className="headerItems"
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            pb={2}
          >
            <Typography
              component="h5"
              fontWeight={500}
              className="pageHeading1"
            >
              Address Information
            </Typography>
          </Box>
          <Box className="viewDetilsBox">
            <>
              <Grid container className="mb-2">
                <GridComp6 title={"BILL TO"} data={el.bill_to} />
                <GridComp6 title={"SHIP TO"} data={el.ship_to} />
              </Grid>
            </>
          </Box>
        </Box>
      ))} */}
      {/*Sales Information*/}
      {/* {rowData.map((el, index) => (
        <Box className="viewBox" key={index}>
          <Box
            className="headerItems"
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            pb={2}
          >
            <Typography
              component="h5"
              fontWeight={500}
              className="pageHeading1"
            >
              Sales Information
            </Typography>
          </Box>
          <Box className="viewDetilsBox">
            <>
              <Grid container className="mb-2">
                <GridComp4 title={"SALES REP"} data={el.sales_rep} />
                <GridComp4
                  title={"SALES EFFECTIVE DATE"}
                  data={el.sale_effective_date}
                />
                 <GridComp4 title={"CREATED FROM"} data={el.created_from} /> 
                {el.linkingorderid === null ? (
                  <></>
                ) : (
                  <Grid item xs={12} sm={6} md={4} className="m-b-10">
                    <p className="tFormlabel">CREATED FROM</p>
                    <p className="tFormName">
                      <Link
                        className="link-color"
                        target="_blank"
                        to={
                          "/transaction-type/" + `${el.linkingtype}` + "/" + `${el.linkingorderid}`
                        }
                      >
                        {el.created_from}
                      </Link>
                    </p>
                  </Grid>
                )}
              </Grid>
            </>
          </Box>
        </Box>
         {el.asc_606_invoice_replacement === "F" ||
            el.asc_606_invoice_replacement === "" ? (
              <Grid item xs={12} className="m-b-10">
                <p className="tFormlabel">
                  <FormGroup>
                    <FormControlLabel
                      control={<checkbox  disabled/>}
                      label="ASC 606 INVOICE REPLACEMENT"
                    />
                  </FormGroup>
                </p>
              </Grid>
            ) : (
              <Grid item xs={12} className="m-b-10">
                <p className="tFormlabel">
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox checked />}
                      label="ASC 606 INVOICE REPLACEMENT"
                    />
                  </FormGroup>
                </p>
              </Grid>
            )}
      ))} */}
     
      <Box>
        <Box
          className="viewBox "
          sx={{
            maxWidth: { xs: "100%", sm: "100%", md: "100%" },
            bgcolor: "#fff",
          }}
        >
          <Tabs
            value={tabIndex}
            onChange={(e, nv) => {
              setTabIndex(nv);
            }}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            className={`${classes.spacedTabs} tabs-bkg`}
          // className="tabs-bkg"
          >
            <Tab style={{ padding: "0px 10px" }} label={`Items ${itemsum}`} />
            <Tab label="Shipping" />
            <Tab label="Billing" />
            <Tab label="Accounting" />
            <Tab label="Relationships" />
            <Tab label="Communication" />
            <Tab label="Related Records" />
            <Tab label="System Information" />
            <Tab label="Custom" />
            <Tab label="Charges" />
            <Tab label="EFT" />
            {/* <Tab label="Tax Reporting" /> */}
            <Tab label="AvaTax" />
          </Tabs>
          {/*------------Items------------*/}
          <TabPanel value={tabIndex} index={0}>
          {tabIndex === 0 &&   <InvoiceItems setSum={setSum} rowData={rowData}/>}
          </TabPanel>
          {/*------------Shipping-----------*/}
          <TabPanel value={tabIndex} index={1}>
          {tabIndex === 1 && <InvoiceShipping tabIndexP={tabIndex} />}
          </TabPanel>
           {/*------------billing-----------*/}
           <TabPanel value={tabIndex} index={2}>
           {tabIndex === 2 &&   <InvoiceBilling tabIndexP={tabIndex} />}
          </TabPanel>
          {/*------------Accounting------------*/}
          <TabPanel value={tabIndex} index={3}>
          {tabIndex === 3 && <InvoiceAccounting tabIndexP={tabIndex} />}
          </TabPanel>
          {/*------------Relationships------------*/}
          <TabPanel value={tabIndex} index={4}>
          {tabIndex === 4 && <InvoiceRelationship tabIndexP={tabIndex} />}
          </TabPanel>
          {/*------------Communication------------*/}
          <TabPanel value={tabIndex} index={5}>
          {tabIndex === 5 && <InvoiceCommunication tabIndexP={tabIndex} />}
          </TabPanel>
          {/*------------Related Record------------*/}
          <TabPanel value={tabIndex} index={6}>
            {tabIndex === 6 && (
              <SalesOrderRelatedRecords tabIndexP={tabIndex} rowData={rowData} />
            )}
          </TabPanel>
          {/*-------------System Information-----------*/}
          <TabPanel value={tabIndex} index={7}>
            {tabIndex === 7 && <InvoiceSystemInformation />}
          </TabPanel>

          {/*-------------CUSTOM-----------*/}
          <TabPanel value={tabIndex} index={8}>
          {tabIndex === 8 &&  <InvoiceCustom tabIndexP={tabIndex} />}
          </TabPanel>
          {/*-------------CHARGES-----------*/}
          <TabPanel value={tabIndex} index={9}>
          {tabIndex === 9 &&  <InvoiceCharges tabIndexP={tabIndex} />}
          </TabPanel>
          {/*------------EFT-----------*/}
          <TabPanel value={tabIndex} index={10}>
          {tabIndex === 10 &&  <InvoiceEft tabIndexP={tabIndex} />}
          </TabPanel>
          {/*-------------Tax Reporting-----------*/}
          {/* <TabPanel value={tabIndex} index={11}>
            <InvoiceTaxAndReporting tabIndexP={tabIndex} />
          </TabPanel> */}
          {/*------------AvaTax-----------*/}
          <TabPanel value={tabIndex} index={11}>
          {tabIndex === 11 &&  <InvoiceAvaTax tabIndexP={tabIndex} />}
          </TabPanel>
        </Box>
      </Box>
    </>
  );
}
